const getCurrentChapterID = (groups = []) => {
  return groups.reduce(
    (_acc, curr) => {
      return curr.current ? curr.chapterid : false;
    },
    { current: false, chapterid: 0 }
  );
};

export { getCurrentChapterID };
